import React from 'react';

const About = () => {
  return (
    <div className="page-content active">
      <section className="hero" style={{ minHeight: '400px' }}>
        <div className="hero-container" style={{ gridTemplateColumns: '1fr' }}>
          <div className="hero-content" style={{ textAlign: 'center' }}>
            <h1>About <span className="highlight">Greenbucks</span></h1>
            <p>Empowering businesses through technology and talent since 2025</p>
          </div>
        </div>
      </section>

      <section className="section">
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          <h2 style={{ fontSize: '2rem', marginBottom: '1.5rem', color: 'var(--primary)' }}>Who We Are</h2>
          <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--text-light)', marginBottom: '2rem' }}>
            Greenbucks Engineering Solution is a forward-thinking IT services company founded in 2025, dedicated to delivering reliable, scalable, and innovative digital solutions. Based in Nashik, Maharashtra, we're building a reputation for quality, integrity, and long-term value creation in everything we do.
          </p>

          <h2 style={{ fontSize: '2rem', marginBottom: '1.5rem', color: 'var(--primary)' }}>What We Do</h2>
          
          <h3 style={{ fontSize: '1.5rem', margin: '2rem 0 1rem', color: 'var(--text)' }}>Technology Solutions</h3>
          <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--text-light)', marginBottom: '2rem' }}>
            Our team builds modern web and mobile applications, optimizes digital platforms, and enables businesses to transform through technology. By combining technical expertise with a client-centric mindset, we help organizations streamline operations, enhance user experience, and achieve sustainable growth.
          </p>

          <h3 style={{ fontSize: '1.5rem', margin: '2rem 0 1rem', color: 'var(--text)' }}>IT Staffing & Resource Solutions</h3>
          <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--text-light)', marginBottom: '2rem' }}>
            We connect businesses with skilled technology professionals who can drive their projects forward. Whether you need dedicated resources for a long-term engagement or specialized talent for a specific initiative, we provide vetted engineers who seamlessly integrate with your team.
          </p>

          <h2 style={{ fontSize: '2rem', margin: '2.5rem 0 1.5rem', color: 'var(--primary)' }}>Our Expertise</h2>
          <div className="services-grid">
            <div style={{ background: 'var(--bg-alt)', padding: '1.5rem', borderRadius: '8px', borderLeft: '4px solid var(--primary)' }}>
              <h4 style={{ marginBottom: '0.5rem' }}>AI & Machine Learning</h4>
              <p style={{ color: 'var(--text-light)' }}>Intelligent systems that learn and adapt</p>
            </div>
            <div style={{ background: 'var(--bg-alt)', padding: '1.5rem', borderRadius: '8px', borderLeft: '4px solid var(--primary)' }}>
              <h4 style={{ marginBottom: '0.5rem' }}>React & Next.js</h4>
              <p style={{ color: 'var(--text-light)' }}>Modern, performant web applications</p>
            </div>
            <div style={{ background: 'var(--bg-alt)', padding: '1.5rem', borderRadius: '8px', borderLeft: '4px solid var(--primary)' }}>
              <h4 style={{ marginBottom: '0.5rem' }}>React Native</h4>
              <p style={{ color: 'var(--text-light)' }}>Cross-platform mobile experiences</p>
            </div>
            <div style={{ background: 'var(--bg-alt)', padding: '1.5rem', borderRadius: '8px', borderLeft: '4px solid var(--primary)' }}>
              <h4 style={{ marginBottom: '0.5rem' }}>Node.js Development</h4>
              <p style={{ color: 'var(--text-light)' }}>Scalable backend solutions</p>
            </div>
            <div style={{ background: 'var(--bg-alt)', padding: '1.5rem', borderRadius: '8px', borderLeft: '4px solid var(--primary)' }}>
              <h4 style={{ marginBottom: '0.5rem' }}>Cloud & Database</h4>
              <p style={{ color: 'var(--text-light)' }}>AWS, MongoDB, efficient data architecture</p>
            </div>
            <div style={{ background: 'var(--bg-alt)', padding: '1.5rem', borderRadius: '8px', borderLeft: '4px solid var(--primary)' }}>
              <h4 style={{ marginBottom: '0.5rem' }}>API & Integration</h4>
              <p style={{ color: 'var(--text-light)' }}>Seamless system connectivity</p>
            </div>
          </div>

          <h2 style={{ fontSize: '2rem', margin: '2.5rem 0 1.5rem', color: 'var(--primary)' }}>Our Values</h2>
          <div style={{ display: 'grid', gap: '1.5rem' }}>
            <div style={{ background: 'white', padding: '1.5rem', borderRadius: '8px', border: '2px solid var(--border)' }}>
              <h4 style={{ color: 'var(--primary)', marginBottom: '0.5rem' }}>Quality First</h4>
              <p style={{ color: 'var(--text-light)' }}>Delivering solutions that meet the highest standards of excellence</p>
            </div>
            <div style={{ background: 'white', padding: '1.5rem', borderRadius: '8px', border: '2px solid var(--border)' }}>
              <h4 style={{ color: 'var(--primary)', marginBottom: '0.5rem' }}>Integrity & Trust</h4>
              <p style={{ color: 'var(--text-light)' }}>Building lasting relationships through transparency and honest communication</p>
            </div>
            <div style={{ background: 'white', padding: '1.5rem', borderRadius: '8px', border: '2px solid var(--border)' }}>
              <h4 style={{ color: 'var(--primary)', marginBottom: '0.5rem' }}>Innovation Driven</h4>
              <p style={{ color: 'var(--text-light)' }}>Staying ahead of technology trends to provide cutting-edge solutions</p>
            </div>
            <div style={{ background: 'white', padding: '1.5rem', borderRadius: '8px', border: '2px solid var(--border)' }}>
              <h4 style={{ color: 'var(--primary)', marginBottom: '0.5rem' }}>True Partnership</h4>
              <p style={{ color: 'var(--text-light)' }}>Working as an extension of your team, invested in your success</p>
            </div>
          </div>

          <div style={{ background: 'var(--bg-alt)', padding: '2rem', borderRadius: '12px', marginTop: '3rem', textAlign: 'center' }}>
            <h3 style={{ color: 'var(--primary)', marginBottom: '1rem' }}>Ready to Work Together?</h3>
            <p style={{ color: 'var(--text-light)', marginBottom: '1.5rem' }}>Whether you need a complete solution or skilled resources, we're here to help</p>
            <a href="mailto:info@greenbucksengg.com" className="btn-primary">Contact Us</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
